export default "__VITE_ASSET__DMkbUj64__"